import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import useDebounce from "../../components/hooks/useDebounce";
import { toast } from "react-toastify";
import { Tag } from "primereact/tag";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";
import Dots from "../../../../assets/assests/detail.png";
import { Button } from "primereact/button";
import Details from "./details_transaction";
export default function TransactionHistoryManagement({
  globalFilter,
  exportCSV,
  statusFilter,
  fromDate,
  toDate,
}) {
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const [rowselect, setRowselect] = useState(null);
  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getTransactionData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/transactions/get-all-paginated`,
        {
          params: {
            pageNumber,
            pageSize,
            searchTerm: debouncedSearch || "",
            status: statusFilter || undefined,
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };
  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons">
     
      
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>

      </div>
    );
  };
  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getTransactionData(pageNumber, rows);
  };

  useEffect(() => {
    getTransactionData();
  }, [debouncedSearch, statusFilter, fromDate, toDate]);

  const columnsData = [
    // {
    //   field: "transactionId",
    //   header: "Transaction Id",
    //   body: (rowData) => rowData.transactionId || "--",
    //   frozen: true,
    // },
    {
      field: "kioskName",
      header: "kiosk Name",
      body: (rowData) => renderTextWithTooltip(rowData, "kioskName", "bottom"),
      frozen: true,
    },
    // {
    //   field: "customerName",
    //   header: "customer Name",
    //   body: (rowData) => rowData.customerName || "--",
    //   frozen: true,
    // },
    {
      field: "customerMobileNumber",
      header: "customer Number",
      body: (rowData) => rowData.customerMobileNumber || "--",
    },
    // {
    //   field: "serviceFee",
    //   header: "service Fee",
    //   body: (rowData) => rowData.serviceFee || "--",
    // },
    {
      field: "amount",
      header: "Amount",
      body: (rowData) => rowData.amount || "--",
    },
    {
      field: "transactionType",
      header: "Transaction Type",
      body: (rowData) => rowData.transactionType || "--",
    },
    // {
    //   field: "recipientName",
    //   header: "recipient Name",
    //   body: (rowData) => rowData.recipientName || "--",
    // },
    // {
    //   field: "recipientMobileNumber",
    //   header: "recipient Mobile Number",
    //   body: (rowData) => rowData.recipientMobileNumber || "--",
    // },
    {
      field: "transactionDate",
      header: "Transaction Date",
      body: (rowData) =>
        rowData.transactionDate
          ? moment(rowData.transactionDate).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    // {
    //   field: "completionDateTime",
    //   header: "completion Date Time",
    //   body: (rowData) =>
    //     rowData.completionDateTime
    //       ? moment(rowData.completionDateTime).format("YYYY-MM-DD HH:mm:ss")
    //       : "--",
    // },
    {
      field: "remarks",
      header: "Remarks",
      body: (rowData) => renderTextWithTooltip(rowData, "remarks", "bottom"),
    },
    {
      field: "status",
      header: "status",
      body: (rowData) => (
        <Tag
          className={
            rowData.status === "Completed"
              ? "custom-success-tag"
              : "custom-danger-tag"
          }
          value={rowData.status ?? "--"}
        />
      ),
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/transactions/get-all`);
      exportToExcel(response.data.body, columnsData, "CustomerTransactionData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }
  return (
  <>
   <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Transaction History Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}
